import { BaseApi } from './base.api.js';

export class ExerciseRecoveryActivityApi extends BaseApi {
    constructor(client) {
        super(client, '/exercise-recovery-activities');
    }
}
